import type { NextPage, GetStaticProps } from "next";
import Link from "next/link";
import Head from "next/head";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React, { useEffect } from "react";

const Home: NextPage = () => {
	const router = useRouter();
	const { t } = useTranslation("common");

	useEffect(() => {
		if (process.env.NODE_ENV === "development") return;
		window.location.replace("https://rockflow.ai");
	}, []);

	return (
		<div>
			<Head>
				<title>RockFlow</title>
				<meta
					name="description"
					content="RockFlow Investment a new method to invest in high-quality assets globally!"
				/>
				<link rel="icon" href="/favicon.ico" />
			</Head>

			<main
				style={{
					opacity: process.env.NODE_ENV === "development" ? 1 : 1,
				}}
			>
				<Link className="block text-center mb-3" href="/" locale={router.locale == "en" ? "zh-Hans" : "en"}>
					{t("change-locale")}
				</Link>
				<span className="text-upColorGreen"></span>
				<span className="text-upColorRed"></span>
				<span className="not-italic text-[#00ADE5]"></span>
				<span className="text-[#FFCF26]"></span>
				<span className="text-[#FE7CFF]"></span>
				<span className="text-[#5BEDF7]"></span>
				<span className="text-[#8267EB]"></span>
				<span className="text-[#16FFFF]"></span>
				<span className="text-[#b7b7b7]"></span>
				<span className="text-[#F9E18A]"></span>
				<span className="text-c887f5"></span>
				<span className="text-[#FDE68A]"></span>
				<span className="text-FFEB86"></span>
				<span className="text-FFF6C9"></span>
				<span className="line-through"></span>
				<span className="text-_6F00FF"></span>
				<Link className="block text-center mb-3" href="/nft/avatars">
					goto nft avatars
				</Link>
				<Link className="block text-center mb-3" href="/nft/covers">
					goto nft covers
				</Link>
				<Link className="block text-center mb-3" href="/policy/openAccount">
					goto policies
				</Link>
				<Link className="block text-center mb-3" href="/login">
					Login
				</Link>
				<Link className="block text-center mb-3" href="/activities/holiday2022">
					goto pulling new
				</Link>
				<Link className="block text-center mb-3" href="/activities/holiday2022/reward">
					goto pulling reward
				</Link>
				<Link className="block text-center mb-3" href="/rapyd">
					rapyd Card
				</Link>
				<Link className="block text-center mb-3" href="/deposit">
					deposit Card
				</Link>
				<Link className="block text-center mb-3" href="/survey/account-opening">
					Open Account
				</Link>
				<Link className="block text-center mb-3" href="/survey/deposit">
					Deposit
				</Link>
				<Link className="block text-center mb-3" href="/survey/address-proof">
					address Proof
				</Link>
				<Link className="block text-center mb-3" href="/copilot?hidden_navigation_bar=1">
					copilot
				</Link>
			</main>
		</div>
	);
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => ({
	props: {
		...(await serverSideTranslations(locale, ["common"])),
	},
});

export default Home;
